import api from './axios';

// returns (and creates if missing) *my* contract for the active cycle
export async function getOrCreateContract() {
    const { data } = await api.get('/api/contracts/mine');
    return data;
}

// explicit, if you want a second name
export async function getMyContract() {
    const { data } = await api.get('/api/contracts/mine');
    return data;
}

// list managed (direct reports) for active cycle by default
export async function getManagedContracts(params = {}) {
    const { data } = await api.get('/api/contracts/managed', { params });
    return data; // paginator { data, meta, ... }
}

// open a specific contract (used when manager opens an employee)
export async function getContract(contractId) {
    const { data } = await api.get(`/api/contracts/${contractId}`);
    return data;
}

export async function approveContractAsUser(id) {
    const { data } = await api.post(`/api/contracts/${id}/approve-user`);
    return data;
}
export async function markContractComplete(id) {
    const { data } = await api.post(`/api/contracts/${id}/complete`);
    return data;
}
export async function approveContractAsManager(id) {
    const { data } = await api.post(`/api/contracts/${id}/approve-manager`);
    return data;
}

export async function validateKpaWeights(contractId) {
    const { data } = await api.post(`/api/contracts/${contractId}/kpas/validate-weights`);
    return data;
}


export async function listStatuses() {
    const { data } = await api.get('/api/statuses');
    return Array.isArray(data) ? data : (data?.data ?? []);
}

export async function setContractStatus(contractId, statusId) {
    const { data } = await api.patch(`/api/contracts/${contractId}`, { status_id: statusId });
    return data;
}